import { useEffect } from "react";
import { Link, useMatch, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { userLoggedOut } from "@features/auth/authSlice";
import useAuthAdmin from "@common/hooks/useAuthAdmin";
import useAuthStudent from "@common/hooks/useAuthStudent";
import logoImage from "@assets/images/learningportal.svg";
import LogoutIcon from "./SVG/LogoutIcon";
import useGetUserData from "@common/hooks/useGetUserData";

const Navbar = () => {
  const dispatch = useDispatch();

  const isAuthAdmin = useAuthAdmin();
  const isAuthStudent = useAuthStudent();

  const navigate = useNavigate();

  const match = useMatch("/admin/*");

  const { name } = useGetUserData() || "";

  useEffect(() => {
    if (match !== null && !isAuthAdmin) {
      navigate("/admin/login");
    }
    if (match === null && !isAuthStudent) {
      navigate("/login");
    }
  }, [match, isAuthAdmin, isAuthStudent, navigate]);

  const handleAdminLogout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
    navigate("/admin/login");
    toast.success("Admin logged out successfully!");
  };

  const handleStudentLogout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
    navigate("/login");
    toast.success("Student logged out successfully!");
  };

  return (
    <nav className="shadow-md">
      <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
        <img className="h-10" src={logoImage} alt="logo" />
        <div className="flex items-center gap-3">
          {match === null && <Link to="/leaderboard">Leaderboard</Link>}
          <Link to={match !== null ? "/admin" : "/"} className="font-bold">
            {match !== null ? "Admin" : name}
          </Link>
          <button
            onClick={match !== null ? handleAdminLogout : handleStudentLogout}
            className={`flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all ${
              match !== null
                ? "bg-red-600 hover:bg-red-700 font-medium"
                : "border border-cyan  hover:bg-cyan"
            }`}
          >
            <LogoutIcon />
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
